



import AccountListComponent from "@/components/admin/account/accountListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "AccountListPage",
  components: {
    AccountListComponent,
  },
})
export default class AccountListPage extends Vue {}
